import { render, staticRenderFns } from "./CardsBlock.vue?vue&type=template&id=5988a8b4&scoped=true"
import script from "./CardsBlock.vue?vue&type=script&lang=js"
export * from "./CardsBlock.vue?vue&type=script&lang=js"
import style0 from "./CardsBlock.vue?vue&type=style&index=0&id=5988a8b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988a8b4",
  null
  
)

export default component.exports